import React from 'react'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import isArray from 'lodash/isArray'
import NotFound from '../Pages/NotFound'
import ManageCoupon from './Coupon/ManageCoupon'
import ManageProvider from './Coupon/ManageProvider'
import ManageAffiliate from './Coupon/ManageAffiliate'

const subList = {
  ManageCoupon: <ManageCoupon />,
  ManageProvider: <ManageProvider />,
  ManageAffiliate: <ManageAffiliate />
}

const SubComponent = ({ subname = 'list' }) => {
  let index = subname
  index = index.split('-')
  if (!isArray(index)) {
    index = upperFirst(index)
  } else {
    index = index.map((el) => upperFirst(el))
    index = index.join('')
  }

  if (has(subList, index)) {
    return subList[index]
  } else {
    return <NotFound />
  }
}

const CouponPage = ({ location, match }) => <SubComponent subname={match.params.sub} location={location} />
export default CouponPage



// WEBPACK FOOTER //
// ./src/Pages/CouponPage.js